// Some of the weirdness needed to make them physics objects
export const fixMeshScaling = (m) => {
    m.scaling.x = Math.abs(m.scaling.x);
    m.scaling.y = Math.abs(m.scaling.y);
    m.scaling.z = Math.abs(m.scaling.z);
};
